import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';

@Component({
  selector: 'ish-product-inventory',
  templateUrl: './product-inventory.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
})
export class ProductInventoryComponent implements OnInit {
  private context = inject(ProductContextFacade);

  visible$: Observable<boolean>;
  available$: Observable<boolean>;
  availableStock$: Observable<number>;
  productType$: Observable<string>;

  ngOnInit() {
    this.visible$ = this.context.select('displayProperties', 'inventory');
    this.available$ = this.context.select('product', 'available');
    this.availableStock$ = this.context.select('product', 'availableStock');
    this.productType$ = this.context.select('product', 'type');
  }
}
